(() => {
  function setup(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const data = JSON.parse(root.querySelector('[data-pdp-data]').textContent);
    const form = root.querySelector('form.pdp-form');
    const money = n => new Intl.NumberFormat(window.BrioI18n.locale, { style: 'currency', currency: data.currency }).format(n / 100);
    const set = (s, text) => { const el = root.querySelector(s); if (el) el.textContent = text; };
    const frequency = root.querySelector('[data-pdp-frequency]');
    const planInput = root.querySelector('[data-pdp-selling-plan]');
    const qty = form.querySelector('[name=quantity]');
    const primaryButton = form.querySelector('[type=submit]');
    const stickyCart = root.querySelector('[data-pdp-sticky-cart]');
    const stickyButton = root.querySelector('[data-pdp-sticky-add]');
    const energyPhoto = root.querySelector('.pdp-photo');
    const mainImage = energyPhoto?.querySelector('[data-pdp-main-image]');
    const photoOverlay = energyPhoto?.querySelector('.pdp-photo-overlays');
    const studio = energyPhoto?.querySelector('[data-pdp-studio]');
    const studioCan = studio?.querySelector('.pdp-studio-can');
    const params = new URLSearchParams(location.search);
    const requestedPlan = params.get('selling_plan');
    root.querySelector('[data-pdp-plan-controls]')?.removeAttribute('hidden');
    let previousVariant;
    function update() {
      if (!root.isConnected) return;
      const variant = data.variants.find(v => String(v.id) === form.querySelector('[name=id]:checked')?.value) || data.variants[0];
      const subscription = form.querySelector('[name=purchase_mode]:checked')?.value === 'subscription';
      const planRadios = [...form.querySelectorAll('[name=pdp_frequency]')];
      planRadios.forEach(r => { r.disabled = !variant.allocations.some(a => String(a.id) === r.value); });
      let radio = planRadios.find(r => r.checked && !r.disabled);
      if (!radio) { radio = planRadios.find(r => !r.disabled); if (radio) radio.checked = true; }
      const allocation = variant.allocations.find(a => String(a.id) === radio?.value);
      const recurring = subscription && !!allocation;
      const selectedPlanId = recurring ? String(radio.value) : '';
      if (frequency) frequency.disabled = !subscription;
      if (planInput) {
        planInput.disabled = !recurring;
        planInput.value = selectedPlanId;
        planInput.setAttribute('value', selectedPlanId);
      }
      const subRadio = form.querySelector('[value=subscription]');
      if (subRadio) { subRadio.disabled = !allocation; if (!allocation && subscription) form.querySelector('[value=once]').checked = true; }
      const price = recurring ? allocation.price : variant.price;
      const units = Number.parseInt(variant.title, 10) || 1;
      set('[data-pdp-price]', money(price));
      set('[data-pdp-unit]', window.BrioI18n.t('s_31bd4dcfd724_html', {units, price: money(price / units), recurring: recurring ? window.BrioI18n.t('s_7b8fdb16e6d3_html') : ''}));
      set('[data-pdp-sticky-price]', money(price));
      set('[data-pdp-sticky-unit]', money(price / units) + ' ' + window.BrioI18n.t('s_68a0cc1827dd_html'));
      set('[data-pdp-sticky-summary]', window.BrioI18n.t('s_506d35aa4557_html', {units, mode: recurring ? window.BrioI18n.t('s_dbbb4e678710_html', {frequency: window.BrioI18n.plan(allocation.name).toLocaleLowerCase(window.BrioI18n.locale)}) : window.BrioI18n.t('s_85da26c6b5ec_html')}));
      set('[data-pdp-sticky-stock]', variant.available ? window.BrioI18n.t('s_a3182e3ccbe1_html') : window.BrioI18n.t('s_68623f989c2a_html'));
      const stickyCompare = root.querySelector('[data-pdp-sticky-compare]');
      if (stickyCompare) { stickyCompare.hidden = !recurring || price >= variant.price; stickyCompare.textContent = recurring && price < variant.price ? money(variant.price) : ''; }
      set('[data-pdp-once-price]', money(variant.price));
      set('[data-pdp-sub-price]', allocation ? money(allocation.price) : window.BrioI18n.t('s_dae75cff3b98_html'));
      set('[data-pdp-sub-original]', allocation && allocation.price < variant.price ? money(variant.price) : '');
      const discount = allocation ? Math.round((1 - allocation.price / variant.price) * 100) : 0;
      const badge = root.querySelector('[data-pdp-discount]');
      if (badge) { badge.hidden = discount <= 0; badge.textContent = `−${discount} %`; }
      const note = root.querySelector('[data-pdp-recurring]');
      if (note) { note.hidden = !recurring; note.textContent = recurring ? window.BrioI18n.t('s_16374faa2780_html', {price: money(price * (Number(qty.value) || 1)), frequency: window.BrioI18n.plan(allocation.name).toLocaleLowerCase(window.BrioI18n.locale)}) : ''; }
      if (previousVariant !== variant.id) {
        const rule = variant.quantity_rule || {};
        qty.min = rule.min || 1; qty.step = rule.increment || 1;
        if (rule.max) qty.max = rule.max; else qty.removeAttribute('max');
        if (!qty.checkValidity()) qty.value = qty.min;
        previousVariant = variant.id;
      }
      const button = form.querySelector('[type=submit]');
      if (form.dataset.busy !== 'true') { button.disabled = !variant.available; set('[data-add-label]', variant.available ? window.BrioI18n.t('s_d18abced4ca2_html') : window.BrioI18n.t('s_68623f989c2a_html')); }
      if (stickyButton) stickyButton.disabled = !variant.available;
      set('[data-pdp-stock]', variant.available ? window.BrioI18n.t('s_a0e764048cd9_html') : window.BrioI18n.t('s_68623f989c2a_html'));
      const url = new URL(location.href); url.searchParams.set('variant', variant.id);
      if (recurring) url.searchParams.set('selling_plan', selectedPlanId); else url.searchParams.delete('selling_plan');
      history.replaceState(null, '', url);
      document.dispatchEvent(new CustomEvent('brio:pdp:update', { detail: { variant, price, units, recurring } }));
    }
    if (requestedPlan) {
      const radio = [...form.querySelectorAll('[name=pdp_frequency]')].find(r => r.value === requestedPlan);
      if (radio) { radio.checked = true; form.querySelector('[value=subscription]').checked = true; }
    } else {
      const fourWeeks = [...form.querySelectorAll('[name=pdp_frequency]')].find(r => data.variants.some(v => v.allocations.some(a => String(a.id) === r.value && /4\s+semaines/i.test(a.name))));
      if (fourWeeks) fourWeeks.checked = true;
    }
    form.addEventListener('change', update);
    qty.addEventListener('input', update);
    form.addEventListener('formdata', event => {
      const subscription = form.querySelector('[name=purchase_mode]:checked')?.value === 'subscription';
      const selectedPlan = form.querySelector('[name=pdp_frequency]:checked:not(:disabled)');
      if (subscription && selectedPlan) event.formData.set('selling_plan', selectedPlan.value);
      else event.formData.delete('selling_plan');
    });
    form.addEventListener('click', event => {
      const stepper = event.target.closest('[data-pdp-quantity]');
      if (!stepper) return;
      if (!qty.value) qty.value = qty.min || 1;
      if (Number(stepper.dataset.pdpQuantity) > 0) qty.stepUp(); else qty.stepDown();
      update();
    });
    let energyTimer;
    const resetEnergy = () => {
      clearTimeout(energyTimer);
      energyPhoto?.classList.remove('is-energy-ramping', 'is-energy-charged');
    };
    const startEnergy = () => {
      if (!energyPhoto || energyPhoto.dataset.imageEnergy !== 'true' || !matchMedia('(hover:hover) and (pointer:fine)').matches || matchMedia('(prefers-reduced-motion:reduce)').matches) return;
      resetEnergy();
      energyPhoto.classList.add('is-energy-ramping');
      energyTimer = setTimeout(() => {
        if (energyPhoto.matches(':hover') && energyPhoto.dataset.imageEnergy === 'true') {
          energyPhoto.classList.remove('is-energy-ramping');
          energyPhoto.classList.add('is-energy-charged');
        } else resetEnergy();
      }, 2400);
    };
    energyPhoto?.addEventListener('pointerenter', startEnergy);
    energyPhoto?.addEventListener('pointerleave', resetEnergy);

    let condensationTimer;
    const condensationAnimations = new Set();
    let condensationVisible = false;
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const condensationDrops = photoOverlay ? [
      { className: 'pdp-condensation-drop pdp-condensation-drop--right', travel: [72, 108] },
      { className: 'pdp-condensation-drop pdp-condensation-drop--left', travel: [58, 92] },
      { className: 'pdp-condensation-drop pdp-condensation-drop--middle', travel: [66, 102] },
      { className: 'pdp-condensation-drop pdp-condensation-drop--edge', travel: [50, 82] },
      { className: 'pdp-condensation-drop pdp-condensation-drop--upper', travel: [48, 76] },
      { className: 'pdp-condensation-drop pdp-condensation-drop--small', travel: [18, 34] }
    ].map(({ className, travel }) => {
      const drop = document.createElement('i');
      drop.className = className;
      drop.dataset.travelMin = travel[0];
      drop.dataset.travelMax = travel[1];
      drop.setAttribute('aria-hidden', 'true');
      photoOverlay.append(drop);
      return drop;
    }) : [];
    const randomBetween = (min, max) => min + Math.random() * (max - min);
    const condensationAllowed = () => condensationVisible && !photoOverlay?.hidden && !reducedMotion.matches && !document.hidden;
    const stopCondensation = () => {
      clearTimeout(condensationTimer);
      condensationAnimations.forEach(animation => animation.cancel());
      condensationAnimations.clear();
      condensationDrops.forEach(drop => {
        drop.dataset.running = 'false';
        drop.style.opacity = '0';
        drop.style.transform = '';
      });
    };
    const scheduleCondensation = (delay = randomBetween(560, 1050)) => {
      clearTimeout(condensationTimer);
      if (!condensationAllowed()) return;
      condensationTimer = setTimeout(() => {
        if (!condensationAllowed()) return;
        const dropPool = (innerWidth <= 560 ? condensationDrops.slice(0, 3) : condensationDrops)
          .filter(drop => drop.dataset.running !== 'true');
        const drop = dropPool[Math.floor(Math.random() * dropPool.length)];
        if (!drop) {
          scheduleCondensation(380);
          return;
        }
        const travel = randomBetween(Number(drop.dataset.travelMin), Number(drop.dataset.travelMax));
        const duration = drop.classList.contains('pdp-condensation-drop--small') ? randomBetween(3600, 4700) : randomBetween(5000, 7200);
        drop.dataset.running = 'true';
        const animation = drop.animate([
          { opacity: 0, transform: 'translate3d(0,0,0) scale(.42,.56)', offset: 0 },
          { opacity: .72, transform: 'translate3d(0,1px,0) scale(.84,.88)', offset: .13 },
          { opacity: 1, transform: 'translate3d(0,4px,0) scale(1,1.04)', offset: .27 },
          { opacity: .98, transform: `translate3d(0,${travel * .27}px,0) scale(.97,1.15)`, offset: .56 },
          { opacity: .94, transform: `translate3d(0,${travel * .72}px,0) scale(.86,1.38)`, offset: .84 },
          { opacity: 0, transform: `translate3d(0,${travel}px,0) scale(.7,1.62)`, offset: 1 }
        ], { duration, easing: 'cubic-bezier(.38,.05,.3,1)', fill: 'none' });
        condensationAnimations.add(animation);
        scheduleCondensation();
        animation.finished.catch(() => {}).finally(() => {
          condensationAnimations.delete(animation);
          drop.dataset.running = 'false';
          drop.style.opacity = '0';
        });
      }, delay);
    };
    const syncCondensation = () => {
      stopCondensation();
      if (condensationAllowed()) scheduleCondensation(randomBetween(180, 420));
    };
    const updateHeroOverlay = () => {
      if (!photoOverlay) return;
      const selected = root.querySelector('[data-pdp-image][aria-pressed="true"]');
      photoOverlay.hidden = selected?.dataset.hero !== 'true' || !mainImage?.classList.contains('is-loaded');
      syncCondensation();
    };
    let photoObserver;
    if (photoOverlay && energyPhoto) {
      const revealInitialPhoto = async () => {
        if (!mainImage || energyPhoto.classList.contains('is-photo-ready')) return;
        try { await mainImage.decode(); } catch (_) { /* A loaded image can still be displayed. */ }
        if (!mainImage.naturalWidth) return;
        requestAnimationFrame(() => {
          mainImage.classList.add('is-loaded');
          energyPhoto.classList.add('is-photo-ready');
          updateHeroOverlay();
        });
        mainImage.removeEventListener('load', revealInitialPhoto);
      };
      mainImage?.addEventListener('load', revealInitialPhoto);
      if (mainImage?.complete && mainImage.naturalWidth) revealInitialPhoto();
      updateHeroOverlay();
      photoObserver = new IntersectionObserver(entries => {
        condensationVisible = entries[0]?.isIntersecting && entries[0].intersectionRatio >= .28;
        syncCondensation();
      }, { threshold: [.1, .28, .55] });
      photoObserver.observe(energyPhoto);
      energyPhoto.addEventListener('pointermove', event => {
        if (!matchMedia('(hover:hover) and (pointer:fine)').matches) return;
        const rect = energyPhoto.getBoundingClientRect();
        energyPhoto.style.setProperty('--pdp-reflect-x', `${((event.clientX - rect.left) / rect.width * 100).toFixed(1)}%`);
        energyPhoto.style.setProperty('--pdp-reflect-y', `${((event.clientY - rect.top) / rect.height * 100).toFixed(1)}%`);
        energyPhoto.classList.add('is-reflecting');
      }, { passive: true });
      energyPhoto.addEventListener('pointerleave', () => energyPhoto.classList.remove('is-reflecting'));
      document.addEventListener('visibilitychange', syncCondensation);
      reducedMotion.addEventListener?.('change', syncCondensation);
    }
    let displayedButton = root.querySelector('[data-pdp-image][aria-pressed="true"]');
    let galleryBusy = false;
    const pause = duration => new Promise(resolve => setTimeout(resolve, duration));
    const selectThumbnail = (button) => root.querySelectorAll('[data-pdp-image]')
      .forEach(item => item.setAttribute('aria-pressed', item === button ? 'true' : 'false'));
    root.querySelector('.pdp-thumbnails').addEventListener('click', async event => {
      const button = event.target.closest('[data-pdp-image]');
      if (!button || galleryBusy || button === displayedButton || !mainImage || !energyPhoto) return;
      galleryBusy = true;
      resetEnergy();
      energyPhoto.setAttribute('aria-busy', 'true');
      let incoming;
      try {
        if (button.dataset.imageStudio === 'true' && studio) {
          if (studioCan && !studioCan.complete) {
            await new Promise(resolve => {
              studioCan.addEventListener('load', resolve, { once: true });
              studioCan.addEventListener('error', resolve, { once: true });
            });
          }
          energyPhoto.dataset.imageStudioActive = 'true';
          studio.classList.add('is-active');
          if (!reducedMotion.matches) await pause(440);
          mainImage.hidden = true;
        } else {
          const preload = new Image();
          preload.decoding = 'async';
          preload.src = button.dataset.pdpImage;
          try { await preload.decode(); } catch (_) { /* Check the loaded image below. */ }
          if (!preload.naturalWidth) throw new Error('Product image unavailable');
          incoming = document.createElement('img');
          incoming.className = 'pdp-photo-transition';
          incoming.src = preload.src;
          incoming.alt = '';
          incoming.style.objectFit = button.dataset.imageFit || 'cover';
          incoming.style.objectPosition = button.dataset.imagePosition || 'center';
          incoming.setAttribute('aria-hidden', 'true');
          energyPhoto.append(incoming);
          if (!reducedMotion.matches) {
            await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
            incoming.classList.add('is-visible');
            await pause(440);
          }
          mainImage.src = preload.src;
          mainImage.alt = button.dataset.imageAlt;
          mainImage.style.objectFit = button.dataset.imageFit || 'cover';
          mainImage.style.objectPosition = button.dataset.imagePosition || 'center';
          mainImage.hidden = false;
          mainImage.classList.add('is-loaded');
          energyPhoto.dataset.imageFit = button.dataset.imageFit || 'cover';
          energyPhoto.dataset.imageEnergy = button.dataset.imageEnergy || 'false';
          energyPhoto.dataset.imageStudioActive = 'false';
          studio?.classList.remove('is-active');
          incoming.remove();
          incoming = null;
        }
        displayedButton = button;
        selectThumbnail(button);
      } catch (_) {
        incoming?.remove();
      } finally {
        galleryBusy = false;
        energyPhoto.removeAttribute('aria-busy');
        updateHeroOverlay();
      }
    });
    if (energyPhoto && mainImage) {
      const thumbnailButtons = [...root.querySelectorAll('.pdp-thumbnails [data-pdp-image]')];
      let swipeStart = null;
      energyPhoto.addEventListener('touchstart', event => {
        if (event.touches.length !== 1 || event.target.closest('.pdp-zoom')) {
          swipeStart = null;
          return;
        }
        const touch = event.touches[0];
        swipeStart = { x: touch.clientX, y: touch.clientY, identifier: touch.identifier };
      }, { passive: true });
      energyPhoto.addEventListener('touchend', event => {
        if (!swipeStart) return;
        const touch = Array.from(event.changedTouches).find(item => item.identifier === swipeStart.identifier);
        if (!touch) return;
        const deltaX = touch.clientX - swipeStart.x;
        const deltaY = touch.clientY - swipeStart.y;
        swipeStart = null;
        if (Math.abs(deltaX) < 42 || Math.abs(deltaX) < Math.abs(deltaY) * 1.25) return;
        const currentIndex = thumbnailButtons.findIndex(button => button.getAttribute('aria-pressed') === 'true');
        const nextIndex = Math.max(0, Math.min(thumbnailButtons.length - 1, currentIndex + (deltaX < 0 ? 1 : -1)));
        thumbnailButtons[nextIndex]?.click();
      }, { passive: true });
      energyPhoto.addEventListener('touchcancel', () => { swipeStart = null; }, { passive: true });
    }
    let cleanupSticky = () => {};
    if (stickyCart && primaryButton) {
      let ticking = false;
      const toggleSticky = () => {
        stickyCart.hidden = primaryButton.getBoundingClientRect().bottom >= 82;
        ticking = false;
      };
      const scheduleSticky = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(toggleSticky);
      };
      addEventListener('scroll', scheduleSticky, { passive: true });
      addEventListener('resize', scheduleSticky);
      cleanupSticky = () => {
        removeEventListener('scroll', scheduleSticky);
        removeEventListener('resize', scheduleSticky);
      };
      stickyButton?.addEventListener('click', () => form.requestSubmit(primaryButton));
      root.querySelector('[data-pdp-sticky-up]')?.addEventListener('click', () => root.querySelector('.pdp-buy')?.scrollIntoView({ behavior: 'smooth', block: 'start' }));
      toggleSticky();
    }
    root.pdpCleanup = () => {
      clearTimeout(energyTimer);
      stopCondensation();
      photoObserver?.disconnect();
      document.removeEventListener('visibilitychange', syncCondensation);
      reducedMotion.removeEventListener?.('change', syncCondensation);
      cleanupSticky();
    };
    update();
  }
  document.querySelectorAll('[data-pdp]').forEach(setup);
  document.addEventListener('shopify:section:load', event => setup(event.target.querySelector('[data-pdp]')));
  document.addEventListener('shopify:section:unload', event => event.target.querySelector('[data-pdp]')?.pdpCleanup?.());
})();
